module.exports = __webpack_public_path__ + "img/coach_lock.4a83a477.svg";